// Versioned consent copy shown to the client in the pre-join lobby.
// Bump CONSENT_COPY_VERSION whenever the wording is materially changed;
// the version is stored alongside each consent record so historical
// consents remain auditable against the exact wording presented.

export const CONSENT_COPY_VERSION = 'v1-2026-04-20';

export const CONSENT_HEADING = 'We save a written record of our sessions';

export const CONSENT_BODY = [
  "For our sessions, AIMHI saves a secure written transcript (no video or audio) so your therapist can reflect on our conversation and plan our work together.",
  "Only you and your assigned therapist can see it. It stays private inside your AIMHI care record."
];

export const CONSENT_CHECKBOX = "I understand and I'm happy to continue.";

export const INCALL_BADGE_LABEL = 'Transcribing';
export const INCALL_BADGE_TOOLTIP =
  'This session is being transcribed (no video or audio recorded). The transcript is private to you and your therapist.';
